import script from "./ArgonPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonPagination.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__